import React from 'react';
import { RadioButton } from '../RadioButton';

interface RadioButtonGroupProps<T = string> {
    options: T[];
    value: T | undefined;
    onValueChange: (value: T) => void;
    getFriendlyNameForOptions: (option: T) => string;
    isDisabled?: boolean;
    name?: string; // For grouping radio buttons
}

export const RadioButtonGroup = <T extends string | number>({
    options,
    value,
    onValueChange,
    getFriendlyNameForOptions,
    isDisabled = false,
    name = 'radio-group'
}: RadioButtonGroupProps<T>) => {
    return (
        <div className="radio-group">
            {options.map((option, index) => (
                <RadioButton
                    key={`${name}-${index}`}
                    name={getFriendlyNameForOptions(option)}
                    value={String(option)}
                    selected={value === option}
                    onValueChange={() => onValueChange(option)}
                    disabled={isDisabled}
                    index={index}
                />
            ))}
        </div>
    );
};
